export class EnumApiShareLink {}
